"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _flow = _interopRequireDefault(require("lodash/fp/flow"));
var _memoize = _interopRequireDefault(require("lodash/memoize"));
var _sortBy = _interopRequireDefault(require("lodash/fp/sortBy"));
var _toPairs = _interopRequireDefault(require("lodash/fp/toPairs"));
var _flat = require("flat");
// lodash/memoize only looks at the first parameter by default
var resolver = (0, _flow["default"])(
// ignore object key ordering
function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return (0, _flat.flatten)(args);
}, _toPairs["default"], (0, _sortBy["default"])('0'), _flat.unflatten,
// if it's good enough for lodash's creator it's good enough for me
// https://github.com/lodash/lodash/issues/2115
JSON.stringify);

// this is the ideal API call.
// you may not like it but this is what peak performance looks like.
/** @deprecated Please use the version found in the `library/` folder instead. */
var _default = exports["default"] = function _default(func) {
  return (0, _memoize["default"])(func, resolver);
};
//# sourceMappingURL=memoize.js.map